export const DESKTOP_SETTINGS_URL: string =
    '/ows/beta/OutlookCloudSettings/settings/account?settingname=desktop_notification_settings';
export const settingName: string = 'desktop_notification_settings';

export enum DesktopNotificationSetting {
    DesktopSettingEnabled = 'DesktopSettingEnabled',
    NewMailNotificationSettingEnabled = 'NewMailNotificationSettingEnabled',
    NewMailNotificationOption = 'NewMailNotificationOption',
    EventReminderNotificationSettingEnabled = 'EventReminderNotificationSettingEnabled',
}

export enum MessageNotificationSetting {
    Inbox,
    Favorite,
}

export type NotificationSettingValue = MessageNotificationSetting | boolean;
